import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from  'primeng/card';
import { RestrictionDialogComponent } from 'src/app/components/restriction-dialog/restriction-dialog.component';
import { RestrictionsTableComponent } from "src/app/components/restrictions-table/restrictions-table.component";
import { RouterModule } from '@angular/router';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-restrictions',
  imports: [RestrictionsTableComponent, RestrictionDialogComponent, ButtonModule, CardModule, RouterModule, HeaderComponent, AsyncPipe],
  templateUrl: './restrictions.component.html',
  styleUrl: './restrictions.component.scss',
  standalone: true,
})
export class RestrictionsComponent {

  showDialog = false;
  isAdmin$ = this.userService.isAdmin$;

  constructor(private userService: UserService) {}

  openDialog() {
    this.showDialog = true;
  }

  handleSave(data: any) {
    this.showDialog = false;  // optional: close dialog on save
  }

}